import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页', icon: 'ri-home-line' },
  { path: '/category/football', label: '赛事分类', icon: 'ri-football-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-fire-fill text-lg md:text-xl text-white"></i>
            </div>
            <div>
              <span className="text-lg md:text-xl font-heading font-bold text-foreground-900 tracking-wide">
                开云体育
              </span>
              <span className="hidden md:block text-[10px] text-foreground-500 -mt-1 tracking-wider">
                KAIYUN SPORTS
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => {
              const isActive =
                link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`relative text-sm font-medium transition-colors duration-200 whitespace-nowrap py-1 ${
                    isActive
                      ? 'text-primary-500'
                      : scrolled
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-foreground-50 hover:text-white'
                  }`}
                >
                  {link.label}
                  {isActive && (
                    <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-5 h-0.5 bg-primary-500 rounded-full" />
                  )}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-5 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              登录
            </a>
            <a
              href="#"
              className="px-5 py-2 text-sm font-semibold bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即注册
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => {
              const isActive =
                link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-600'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${link.icon} text-lg`}></i>
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/70">
              <a
                href="#"
                className="flex-1 px-4 py-2.5 text-center text-sm font-medium text-foreground-700 border border-background-300 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
              >
                登录
              </a>
              <a
                href="#"
                className="flex-1 px-4 py-2.5 text-center text-sm font-semibold bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors cursor-pointer"
              >
                立即注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}